import React from 'react'

import InvoiceOverlayModal from '../modals'
import Button, { ButtonSize, ButtonVariant } from '../ui/button'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isSending?: boolean
}

const ZeroTotalSendModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isSending = false,
}) => {
  return (
    <InvoiceOverlayModal
      open={open}
      onClose={onClose}
      title='Invoice total is 0'
      description='Do you want to send anyway?'
    >
      <div className='d-flex justify-content-between pt-2'>
        <Button
          type='button'
          size={ButtonSize.LARGE}
          variant={ButtonVariant.LIGHT}
          onClick={onClose}
          disabled={isSending}
        >
          Cancel
        </Button>
        <Button
          type='button'
          size={ButtonSize.LARGE}
          loading={isSending}
          loadingText='Saving'
          onClick={onConfirm}
          disabled={isSending}
        >
          Send anyway
        </Button>
      </div>
    </InvoiceOverlayModal>
  )
}

export default ZeroTotalSendModal
